import React, { useEffect, useState } from "react";
import { Transaction } from "./interface";
import { format } from "date-fns";
import { API_ROUTES } from "@/services/environment";
import { GET } from "@/services/api";
import { useAppSelector } from "@/hooks/hook";
import { convertCentsToDollars, Loader, USFormatePriceWithDecimal } from "@thdinc/hpf-shared";

interface TransactionTable {
  // transactions: Transaction[];
  bookingId: string;
}

const TransactionTable: React.FC<TransactionTable> = ({ bookingId }) => {
  const { getBookingTransactionApi } = API_ROUTES;
  const { refreshToken } = useAppSelector((store) => store.user);
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  useEffect(() => {
    (async () => {
      const res = await GET(
        `${getBookingTransactionApi}/${bookingId}`,
        refreshToken
      );

      if (res.data.success) {
        setTransactions(res.data.data);
      }
    })();
  }, [bookingId]);
  return (
    <div className="pb-10">
      <div className="relative overflow-x-auto   rounded-2xl mt-4 overflow-y-auto max-h-full ">
        {transactions.length > 0 ? (
          <table className="w-full text-sm text-left rtl:text-right bg-p-gray ">
            <thead className="text-xs text-gray-700 uppercase border-b">
              <tr>
                <th scope="col" className="px-2 sm:px-5  py-4 uppercase">
                  Date
                </th>
                <th
                  scope="col"
                  className="px-2 sm:px-5  py-4 uppercase min-w-36"
                >
                  Total Charged
                </th>

                <th
                  scope="col"
                  className="px-2 sm:px-5  py-4 uppercase min-w-36"
                >
                  Platform Fee
                </th>
                <th
                  scope="col"
                  className="px-2 sm:px-5  py-4 uppercase min-w-48"
                >
                  Amount Transferred
                </th>
                <th
                  scope="col"
                  className="px-2 sm:px-5  py-4 uppercase min-w-36"
                >
                  Transferred To
                </th>
                <th
                  scope="col"
                  className="px-2 sm:px-5  py-4 uppercase min-w-28"
                >
                  Type
                </th>
                <th
                  scope="col"
                  className="px-2 sm:px-5  py-4 uppercase min-w-28"
                >
                  Description
                </th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((item: Transaction, index) => {
                const { amount, application_charges, hows, date } = item;
                return (
                  <tr key={index} className=" 0   border-b">
                    <td className="px-2 sm:px-4 py-4 min-w-28 text-center">
                      {format(date, "MM-dd-yyyy")}
                    </td>
                    <td className="px-2 sm:px-4 py-4 min-w-28 text-center">
                      {amount && (
                        <p>
                          ${""}
                          {USFormatePriceWithDecimal(
                            convertCentsToDollars(amount?.toString())
                          )}
                        </p>
                      )}
                    </td>

                    <td className="px-2 sm:px-4 py-4  min-w-28 text-center">
                      <p>
                        {`${
                          application_charges
                            ? `$${USFormatePriceWithDecimal(
                                convertCentsToDollars(
                                  application_charges?.toString()
                                )
                              )}`
                            : "-"
                        }`}
                      </p>
                    </td>
                    <td className="px-2 sm:px-4 py-4 text-sm  text-center">
                      {item.amount_transfered ? (
                        <p>
                          ${""}
                          {USFormatePriceWithDecimal(
                            convertCentsToDollars(
                              item.amount_transfered?.toString()
                            )
                          )}
                        </p>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="px-2 sm:px-4 py-4 text-sm text-center">
                      <p>{hows ? "HOWS" : "BTC"}</p>
                    </td>
                    <td className="px-2 sm:px-4 py-4 text-sm min-w-48 ">
                      <p>{item.type}</p>
                    </td>
                    <td className="px-2 sm:px-4 py-4 text-sm min-w-48 ">
                      <p>{item.description}</p>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <Loader color="bg-red-500" />
        )}
      </div>
    </div>
  );
};

export default TransactionTable;
